import { Buffer } from 'buffer';
import urls, { relativeUrl } from '@/constants/urls';
import { defaultFacetRequest } from './constants';
import { updateSearchProperties, performFind } from './actions';

export const convertConfigFacetsToMap = (configFacetsList) => (
  configFacetsList.reduce((currentMap, currentFacetConfig) => {
    const newMap = { ...currentMap };
    newMap[currentFacetConfig.name] = currentFacetConfig;
    return newMap;
  }, {})
);

export const buildFacetRequest = (facets) => (
  facets.reduce((facetRequest, facetConfig) => {
    const newFacetRequest = { ...facetRequest };
    // Build new Values
    newFacetRequest[facetConfig.name] = facetConfig.config ? { ...facetConfig.config } : defaultFacetRequest;
    return newFacetRequest;
  }, {})
);

export const encodeQuery = (query = '', filter = {}) => {
  const data = {
    filter,
    query,
    hostname: window.location.hostname,
  };
  const bytes = Buffer.from(JSON.stringify(data)).toString('base64');
  return `${window.location.protocol}//${window.location.host}/#${relativeUrl(urls.SEARCH)}${encodeURI(bytes)}`;
};

export const encodeQueryOmni = (query = '') => {
  const bytes = Buffer.from(JSON.stringify({
    query,
    hostname: window.location.hostname,
  })).toString('base64');
  return `${relativeUrl(urls.SEARCH)}${encodeURI(bytes)}`;
};

export const updateFilterValues = (category, code, filter, lastEdited) => updateSearchProperties(
  category,
  code,
  { filter, lastEdited },
);

export const performFacetedSearch = (category, code) => performFind(
  category,
  code,
  1,
  null,
  false,
  null,
  null,
);
